import {Component, Input, OnInit} from '@angular/core';
import {StarRatingComponent} from 'ng-starrating';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import Env from '../../../../../env/env';
import {MatSnackBar} from '@angular/material/snack-bar';

interface MarkResponse {
  id: number;
  mark: number;
}

@Component({
  selector: 'app-result-rating',
  templateUrl: './result-rating.component.html',
  styleUrls: ['./result-rating.component.css']
})
export class ResultRatingComponent implements OnInit {
  mark = 0;
  @Input() id: number;

  constructor(private http: HttpClient, private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.http.get<MarkResponse>(Env.apiUrl + `/rating/${this.id}`).subscribe((data) => {
      this.mark = data.mark;
    });
  }

  onRate($event: { oldValue: number, newValue: number, starRating: StarRatingComponent }) {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');

    this.http.put(Env.apiUrl + `/rating/${this.id}`, { mark: $event.newValue }, { headers }).subscribe((data) => {

      this.snackBar.open('Rating saved', 'close', {
        duration: 2000,
      });
    });
  }
}
